import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
   root: {
      paddingTop: 30,
   },
   version : {
      textAlign : 'left' ,
      padding: 10
   }
}))
